<div class="col-xl">
    <form [formGroup]="unitForm" id="formUnit" (ngSubmit)="updateUnit()">
        <div class="card mb-4">
            <div class="card-header d-flex justify-content-between align-items-center">
                <h5 class="mb-0">Actualización de unidad</h5>
            </div>
            <div class="card-body">
                <div class="mb-3 p-3 border rounded">
                    <div class="row">
                        <h5 class="mb-0">Datos de la unidad</h5>
                    </div>
                    <div class="row mt-3">
                        <div class="col">
                            <label class="form-label" for="basic-default-company">Unidad*</label>
                            <div class="input-group input-group-merge">
                                <select class="form-control" id="basic-default-company" [(ngModel)]="formModelData.type" [ngClass]="unitForm.controls['type'].errors  && !unitForm.controls['type'].pristine ? 'is-invalid' : ''"
                                    formControlName="type">
                                    <option value="">Seleccione una opción</option>
                                    <option value="1">Tipo Partner</option>
                                    <option value="2">Tipo Panel</option>
                                    <option value="3">Tipo crafter</option>
                                    <option value="4">RAM</option>
                                    <option value="5">Torton</option>
                                    <option value="6">Tracto</option>
                                </select>
                                <div class="invalid-feedback" *ngIf="unitForm.controls['type'].errors  && !unitForm.controls['type'].pristine">
                                    El campo unidad es obligatorio
                                </div>
                            </div>
                        </div>
                        <div class="col">
                            <label class="form-label" for="basic-default-company">Nombre de la unidad*</label>
                            <div class="input-group input-group-merge">
                                <input type="text" class="form-control" id="basic-default-company" [(ngModel)]="formModelData.unit" [ngClass]="unitForm.controls['unit'].errors  && !unitForm.controls['unit'].pristine ? 'is-invalid' : ''"
                                    formControlName="unit">
                                <div class="invalid-feedback" *ngIf="unitForm.controls['unit'].errors  && !unitForm.controls['unit'].pristine">
                                    El campo unidad es obligatorio
                                </div>
                            </div>
                        </div>
                        <div class="col">
                            <label class="form-label" for="basic-default-company">Placas*</label>
                            <div class="input-group input-group-merge">
                                <input type="text" class="form-control" id="basic-default-company" [(ngModel)]="formModelData.plates" [ngClass]="unitForm.controls['plates'].errors  && !unitForm.controls['plates'].pristine ? 'is-invalid' : ''"
                                formControlName="plates">
                                <div class="invalid-feedback" *ngIf="unitForm.controls['plates'].errors  && !unitForm.controls['plates'].pristine">
                                    El campo placas es obligatorio
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row mt-3">
                        <div class="col">
                            <label class="form-label">Año de la unidad*</label>
                            <input type="date" class="form-control" [(ngModel)]="formModelData.unit_year" [ngClass]="unitForm.controls['unit_year'].errors && !unitForm.controls['unit_year'].pristine ? 'is-invalid' : ''" formControlName="unit_year">
                        </div>
                        <div class="col">
                            <label class="form-label">La unidad cuenta con placa federal*</label>
                            <div class="d-flex gap-3 mt-2">
                                <div class="form-check">
                                    <input class="form-check-input" type="radio" name="hasFederalPlate" id="hasFederalPlateYes" [value]="true" [(ngModel)]="formModelData.has_federal_plate" formControlName="has_federal_plate">
                                    <label class="form-check-label" for="hasFederalPlateYes">Si</label>
                                </div>
                                <div class="form-check">
                                    <input class="form-check-input" type="radio" name="hasFederalPlate" id="hasFederalPlateNo" [value]="false" [(ngModel)]="formModelData.has_federal_plate" formControlName="has_federal_plate">
                                    <label class="form-check-label" for="hasFederalPlateNo">No</label>
                                </div>
                            </div>
                        </div>
                        <div class="col">
                            <label class="form-label">Checklist del estado de mantenimiento*</label><br>
                            <a href="javascript:void(0)" (click)="goToChecklist()" class="evidence-link">Subir checklist del estado de mantenimiento</a>
                        </div>
                    </div>
                    <div class="row mt-3">
                        <div class="col">
                            <label class="form-label">Peso bruto</label>
                            <input type="number" class="form-control" [(ngModel)]="formModelData.peso_bruto" formControlName="peso_bruto">
                        </div>
                        <div class="col">
                            <label class="form-label">Número de motor</label>
                            <input type="text" class="form-control" [(ngModel)]="formModelData.numero_motor" formControlName="numero_motor">
                        </div>
                        <div class="col">
                            <label class="form-label">&nbsp;</label>
                        </div>
                    </div>
                </div>

                <div class="mb-3 p-3 border rounded">
                    <div class="row">
                        <h5 class="mb-0">Datos de verificación vehicular</h5>
                    </div>
                    <div class="row mt-3">
                        <div class="col">
                            <label class="form-label">Fecha última verificación*</label>
                            <input type="date" class="form-control" [(ngModel)]="formModelData.last_verification_date" [ngClass]="unitForm.controls['last_verification_date'].errors && !unitForm.controls['last_verification_date'].pristine ? 'is-invalid' : ''" formControlName="last_verification_date">
                        </div>
                        <div class="col">
                            <label class="form-label">Fecha siguiente verificación*</label>
                            <input type="date" class="form-control" [(ngModel)]="formModelData.next_verification_date" [ngClass]="unitForm.controls['next_verification_date'].errors && !unitForm.controls['next_verification_date'].pristine ? 'is-invalid' : ''" formControlName="next_verification_date">
                        </div>
                    </div>
                    <div class="row mt-3">
                        <div class="col">
                            <input type="file" #verificationEvidenceInput class="d-none" (change)="onFileChange($event, 'verification_evidence')" formControlName="verification_evidence">
                            <a class="evidence-link" href="javascript:void(0)" (click)="$event.preventDefault(); verificationEvidenceInput.click();">Subir evidencia verificación</a>
                            <div *ngIf="verificationEvidencePreviewUrl" class="mt-2">
                                <a [href]="verificationEvidencePreviewUrl" target="_blank" rel="noopener">Ver evidencia</a>
                            </div>
                            <div *ngIf="formModelData?.verification_evidence_path" class="mt-2">
                                <a [href]="urlPage + '/storage/' + formModelData.verification_evidence_path" target="_blank" rel="noopener">Ver evidencia</a>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="mb-3 p-3 border rounded">
                    <div class="row">
                        <h5 class="mb-0">Físico-Mecánica</h5>
                    </div>
                    <div class="row mt-3">
                        <div class="col">
                            <input type="file" #autogafaEvidenceInput class="d-none" (change)="onFileChange($event, 'autogafa_evidence')" formControlName="autogafa_evidence">
                            <a class="evidence-link" href="javascript:void(0)" (click)="$event.preventDefault(); autogafaEvidenceInput.click();">Subir evidencia autógrafa</a>
                            <div *ngIf="autogafaEvidencePreviewUrl" class="mt-2">
                                <a [href]="autogafaEvidencePreviewUrl" target="_blank" rel="noopener">Ver evidencia</a>
                            </div>
                            <div *ngIf="formModelData?.autogafa_evidence_path" class="mt-2">
                                <a [href]="urlPage + '/storage/' + formModelData.autogafa_evidence_path" target="_blank" rel="noopener">Ver evidencia</a>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="mb-3 p-3 border rounded">
                    <div class="row">
                        <h5 class="mb-0">Permiso SCT</h5>
                    </div>
                    <div class="row mt-3">
                        <div class="col">
                            <label class="form-label">Tipo de permiso*</label>
                            <select class="form-control" [(ngModel)]="formModelData.permit_type_id" [ngClass]="unitForm.controls['permit_type_id'].errors && !unitForm.controls['permit_type_id'].pristine ? 'is-invalid' : ''" formControlName="permit_type_id">
                                <option value="">Seleccione una opción</option>
                                <option *ngFor="let p of permitTypes" [value]="p.id">{{p.key}} - {{p.description}}</option>
                            </select>
                        </div>
                        <div class="col">
                            <label class="form-label">Número de permiso*</label>
                            <input type="text" class="form-control" [(ngModel)]="formModelData.permit_number" [ngClass]="unitForm.controls['permit_number'].errors && !unitForm.controls['permit_number'].pristine ? 'is-invalid' : ''" formControlName="permit_number">
                        </div>
                        
                    </div>
                    <div class="row mt-3">
                        <div class="row">
                            <div class="col">
                                <label class="form-label">Tipo de remolque*</label>
                                <select class="form-control" [(ngModel)]="formModelData.vehicle_configuration_id" [ngClass]="unitForm.controls['vehicle_configuration_id'].errors && !unitForm.controls['vehicle_configuration_id'].pristine ? 'is-invalid' : ''" formControlName="vehicle_configuration_id">
                                    <option value="">Seleccione una opción</option>
                                    <option *ngFor="let v of vehicleConfigurations" [value]="v.id">{{v.code}} - {{v.description}}</option>
                                </select>
                            </div>
                            <div class="col d-flex align-items-start info pt-3">
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none" class="me-2 mt-1">
                                    <g clip-path="url(#clip0_281_3600)">
                                        <path d="M18.3332 10C18.3332 5.39767 14.6022 1.66671 9.99984 1.66671C5.39746 1.66671 1.6665 5.39767 1.6665 10C1.6665 14.6024 5.39746 18.3334 9.99984 18.3334C14.6022 18.3334 18.3332 14.6024 18.3332 10Z" stroke="#019DDA" stroke-width="1.5"/>
                                        <path d="M10.202 14.1667V10C10.202 9.60718 10.202 9.41076 10.0799 9.28873C9.95791 9.16669 9.76149 9.16669 9.36865 9.16669" stroke="#019DDA" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                        <path d="M9.99349 6.66669H10.001" stroke="#019DDA" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                    </g>
                                    <defs>
                                        <clipPath id="clip0_281_3600">
                                        <rect width="20" height="20" fill="white"/>
                                        </clipPath>
                                    </defs>
                                </svg>
                                <label for="">
                                    Selecciona el tipo de remolque según la unidad:
                                    <ul>
                                        <li>Tracto → T3S2 (requiere remolque)</li>
                                        <li>Torton → C3 (sin remolque) o C3R2 (con remolque)</li>
                                        <li>Unidades ligeras → C2 (sin remolque)</li>
                                    </ul>
                                </label>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="mb-3 p-3 border rounded">
                    <div class="row">
                        <h5 class="mb-0">Seguros</h5>
                    </div>
                    <div class="row mt-3">
                        <div class="col">
                            <label class="form-label">Aseguradora*</label>
                            <select class="form-control" [(ngModel)]="formModelData.insurer_id" [ngClass]="unitForm.controls['insurer_id'].errors && !unitForm.controls['insurer_id'].pristine ? 'is-invalid' : ''" formControlName="insurer_id">
                                <option value="">Seleccione una opción</option>
                                <option *ngFor="let i of insurers" [value]="i.id">{{i.name}}</option>
                            </select>
                        </div>
                        <div class="col">
                            <label class="form-label">Número de póliza*</label>
                            <input type="text" class="form-control" [(ngModel)]="formModelData.policy_number" [ngClass]="unitForm.controls['policy_number'].errors && !unitForm.controls['policy_number'].pristine ? 'is-invalid' : ''" formControlName="policy_number">
                        </div>
                    </div>
                    <div class="row mt-3">
                        <div class="col">
                            <label class="form-label">Aseguradora Responsabilidad Civil*</label>
                            <select class="form-control" [(ngModel)]="formModelData.liability_insurer_id" [ngClass]="unitForm.controls['liability_insurer_id'].errors && !unitForm.controls['liability_insurer_id'].pristine ? 'is-invalid' : ''" formControlName="liability_insurer_id">
                                <option value="">Seleccione una opción</option>
                                <option *ngFor="let i of insurers" [value]="i.id">{{i.name}}</option>
                            </select>
                        </div>
                        <div class="col">
                            <label class="form-label">Póliza Responsabilidad Civil*</label>
                            <input type="text" class="form-control" [(ngModel)]="formModelData.liability_policy_number" [ngClass]="unitForm.controls['liability_policy_number'].errors && !unitForm.controls['liability_policy_number'].pristine ? 'is-invalid' : ''" formControlName="liability_policy_number">
                        </div>
                    </div>
                    <div class="row mt-3">
                        <div class="col">
                            <label class="form-label">Aseguradora daños al medio ambiente</label>
                            <select class="form-control" [(ngModel)]="formModelData.environmental_insurer_id" formControlName="environmental_insurer_id">
                                <option value="">Seleccione una opción</option>
                                <option *ngFor="let i of insurers" [value]="i.id">{{i.name}}</option>
                            </select>
                        </div>
                        <div class="col">
                            <label class="form-label">Póliza daños al medio ambiente</label>
                            <input type="text" class="form-control" [(ngModel)]="formModelData.environmental_policy_number" formControlName="environmental_policy_number">
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="card mb-4">
            <div class="card-body text-center">
                <button type="submit" class="btn btn-primary me-sm-3 me-1">Actualizar Unidad</button>
            </div>
        </div>
    </form>
</div>

<ngx-spinner bdColor="rgba(0, 0, 0, 0.7)" size="medium" color="#fff" type="ball-atom">
    <div class="loader"></div>
    <p style="font-size: 20px; color: white">Espere un momento...</p>
</ngx-spinner>